<nav class="punches-nav" [class.hidden]="isHidden" aria-label="Punches navigation">
  <div class="nav-shell">
    <div class="nav-scroll">
      <ul class="nav-segment" role="tablist">
        <li role="presentation">
          <a
            #navLink
            routerLink="/timesheets/daily-punches"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Daily Punches
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/timesheets/violations"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Violations
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/timesheets/punch-history"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Punch History
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>